export default __webpack_public_path__ + "assets/images/error-img.5d6ef8ca77cc1b42a270e02fd43e7ba9.png";